import { useState } from "react"

export const SocialMediaInsight = () => {
    const [accessToken, setAccessToken] = useState('');
    const [instagramAccessToken, setInstagramAccessToken] = useState('');
    const [linkedInAccessToken, setLinkedInAccessToken] = useState('');
    const [urlCode, setUrlCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [accountNotConnected, setAccountNotConnected] = useState(true);
    const [selectedPlatform, setSelectedPlatform] = useState('');
    const [connectedPlatform, setConnectedPlatform] = useState('');
    const [insightLoading, setInsightLoading] = useState(false);
    const [viewsLoading, setViewsLoading] = useState(false);
    const [followsLoading, setFollowsLoading] = useState(false);
    const [messagingLoading, setMessagingLoading] = useState(false);
    const [reachLoading, setReachLoading] = useState(false);
    const [linkClicksLoading, setLinkClicksLoading] = useState(false);
    const [topContentsLoading, setTopContentsLoading] = useState(false);
    const [insightData, setInsightData] = useState(null);
    const [viewsData, setViewsData] = useState(null);
    const [followsData, setFollowsData] = useState(null);
    const [messagingData, setMessagingData] = useState(null);
    const [reachData, setReachData] = useState(null);
    const [linkClicksData, setLinkClicksData] = useState(null);
    const [topContentsData, setTopContentsData] = useState(null);
    const [viewFilter, setViewFilter] = useState('lastWeek');
    const [viewCustomRange, setViewCustomRange] = useState({
        start: null,
        end: null,
    });
    const [followFilter, setFollowFilter] = useState('lastWeek');
    const [followCustomRange, setFollowCustomRange] = useState({
        start: null,
        end: null,
    });
    const [messagingFilter, setMessagingFilter] = useState('lastWeek');
    const [messagingCustomRange, setMessagingCustomRange] = useState({
        start: null,
        end: null,
    });
    const [reachFilter, setReachFilter] = useState('lastWeek');
    const [reachCustomRange, setReachCustomRange] = useState({
        start: null,
        end: null,
    });
    const [linkClicksFilter, setLinkClicksFilter] = useState('lastWeek');
    const [linkClicksCustomRange, setLinkClicksCustomRange] = useState({
        start: null,
        end: null,
    });
    const [showReconnectModal, setShowReconnectModal] = useState(false);
    const [showProfilesModal, setShowProfilesModal] = useState(false);
    const [profilePages, setProfilePages] = useState([]);
    const [profilePagesLoading, setProfilePagesLoading] = useState(false);
    const [selectedProfileId, setSelectedProfileId] = useState('');
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [allViewsData, setAllViewsData] = useState([]);
    const [instagramAccountId, setInstagramAccountId] = useState('');
    const [linkedInAccountId, setLinkedInAccountId] = useState('');

    return {
        urlCode: { data: urlCode, set: setUrlCode },
        loading: { data: loading, set: setLoading },
        accountNotConnected: { data: accountNotConnected, set: setAccountNotConnected },
        selectedPlatform: { data: selectedPlatform, set: setSelectedPlatform },
        connectedPlatform: { data: connectedPlatform, set: setConnectedPlatform },
        insightLoading: { data: insightLoading, set: setInsightLoading },
        viewsLoading: { data: viewsLoading, set: setViewsLoading },
        followsLoading: { data: followsLoading, set: setFollowsLoading },
        messagingLoading: { data: messagingLoading, set: setMessagingLoading },
        reachLoading: { data: reachLoading, set: setReachLoading },
        linkClicksLoading: { data: linkClicksLoading, set: setLinkClicksLoading },
        topContentsLoading: { data: topContentsLoading, set: setTopContentsLoading },
        insightData: { data: insightData, set: setInsightData },
        reachData: { data: reachData, set: setReachData },
        viewsData: { data: viewsData, set: setViewsData },
        followsData: { data: followsData, set: setFollowsData },
        messagingData: { data: messagingData, set: setMessagingData },
        linkClicksData: { data: linkClicksData, set: setLinkClicksData },
        topContentsData: { data: topContentsData, set: setTopContentsData },
        viewFilter: { data: viewFilter, set: setViewFilter },
        viewCustomRange: { data: viewCustomRange, set: setViewCustomRange },
        followFilter: { data: followFilter, set: setFollowFilter },
        followCustomRange: { data: followCustomRange, set: setFollowCustomRange },
        messagingFilter: { data: messagingFilter, set: setMessagingFilter },
        messagingCustomRange: { data: messagingCustomRange, set: setMessagingCustomRange },
        reachFilter: { data: reachFilter, set: setReachFilter },
        reachCustomRange: { data: reachCustomRange, set: setReachCustomRange },
        linkClicksFilter: { data: linkClicksFilter, set: setLinkClicksFilter },
        linkClicksCustomRange: { data: linkClicksCustomRange, set: setLinkClicksCustomRange },
        showReconnectModal: { data: showReconnectModal, set: setShowReconnectModal },
        showProfilesModal: { data: showProfilesModal, set: setShowProfilesModal },
        profilePages: { data: profilePages, set: setProfilePages },
        selectedProfileId: { data: selectedProfileId, set: setSelectedProfileId },
        selectedProfile: { data: selectedProfile, set: setSelectedProfile },
        searchQuery: { data: searchQuery, set: setSearchQuery },
        accessToken: { data: accessToken, set: setAccessToken },
        allViewsData: { data: allViewsData, set: setAllViewsData },
        instagramAccountId: { data: instagramAccountId, set: setInstagramAccountId },
        instagramAccessToken: { data: instagramAccessToken, set: setInstagramAccessToken },
        profilePagesLoading: { data: profilePagesLoading, set: setProfilePagesLoading },
        linkedInAccountId: { data: linkedInAccountId, set: setLinkedInAccountId },
        linkedInAccessToken: { data: linkedInAccessToken, set: setLinkedInAccessToken },
    }
}
